
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
    name: "Pager",
    computed: mapGetters({
        pager: 'getPager',
        nextPageUrl: 'getNextPageUrl'
    }),
    setup() {
        const scrollTop = (): void => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }

        return {
            scrollTop
        }
    },
    methods: {
        ...mapActions({
            loadProducts: 'LOAD_PRODUCTS'
        }),
        changePage(url: string) {
            this.loadProducts({url: url})
        },
        loadMore(url: string) {
            this.loadProducts({url: url, appendProducts: true})
        }
    }
});
